import * as yup from "yup";

export const UsuarioValidate = yup.object().shape({
  roles: yup.array().of(
      yup.object().shape({
        idrol: yup.number().required("Debe indicar Rol"),
        idunidad: yup.number().required("Debe indicar Unidad"),
        estado: yup.string().required("Debe indicar Estado")
      })
    )
});

export const SolicitudProyValidate = yup.object().shape({
        cabecera: yup.object().shape({
            justificacion: yup.string().trim().required("Debe justificar la solicitud."),
            tipoSolicitud: yup.string().trim().required("Seleccione el tipo."),
            fechaAmpliacion: yup.date().when('tipoSolicitud', {
                is: 'A' || 'F',
                then: (schema) => schema.required(),
                otherwise: (schema) => schema.notRequired(),
                // then: (schema) => schema.required('Fecha de fin es requerida para proyectos a largo plazo'),
                // otherwise: yup.date().notRequired(),
            }),
        })
});

export const EstudianteActivoValidate = yup.object().shape({
  codestudiante: yup.string().trim().required("Ingrese una matricula")
  .matches(/^\d{9}$/, "La matrícula debe tener exactamente 9 dígitos"),
});



// Esquema de validación usando Yup para el formulario Itinerario


export const SolicitudItinerarioValidate = yup.object().shape({
  itinerario: yup.object().shape({
    temainv: yup.string().trim().required('El tema es requerido')
    .test('requiredIfLegth', 'Se excedio el máximo de caracteres 300', function (value) {
      return value !== undefined ? value.length <= 300 : true;
    }),
    codigomateria: yup.string().trim().required('La materia es requerida'),
    mailtutor: yup.string().trim().required('El tutor es requerido'),
    objgeneral: yup.string().trim().required('El objetivo general es requerido')
    .test('requiredIfLegth', 'Se excedio el máximo de caracteres 300', function (value) {
      return value !== undefined ? value.length <= 300 : true;
    }),
  }),
  objespecificos: yup.array().of(
    yup.object().shape({
      objespec: yup.string().required('El objetivo específico es requerido')
      .test('requiredIfLegth', 'Se excedio el máximo de caracteres 300', function (value) {
        return value !== undefined ? value.length <= 300 : true;
      }),
    })
  ).test('min-length', 'Debe agregar al menos un objetivo específico', function (value) {
        return value && value.length > 0;
  }),
  cronograma: yup.array().of(
    yup.object().shape({
      actividad: yup.string().trim().required('La actividad es requerida')
      .test('requiredIfLegth', 'Se excedio el máximo de caracteres 300', function (value) {
        return value !== undefined ? value.length <= 300 : true;
      }),
      fechainicio: yup.date().required('La fecha de inicio es requerida').nullable(),
      fechafin: yup.date().required('La fecha de fin es requerida').nullable(),
      presencial: yup.boolean(),
    })
  ).test('min-length', 'Debe haber varias actividades en la lista', function (value) {
    return value && value.length > 1;
  })
});

